import axios from "axios";

export const sendMessage = async (values) => {
    const response = await axios.post("https://submit-form.com/7wNiIj7w", values)
    return response;
}
